import axios from 'axios';
import { API_BASE } from '../config';

// P7.2: server-side quote (respects org price rules). Callers fall back to the
// local getEquipmentDailyRate calc (dupes intentionally kept, see CLAUDE.md) on error.
export function quoteKey(equipmentIds, dateFrom, dateTo) {
  const ids = Array.isArray(equipmentIds) ? [...equipmentIds].sort((a, b) => a - b).join(',') : '';
  return `${ids}|${dateFrom || ''}|${dateTo || ''}`;
}

// `regulaDomyslna`: wycena rezerwacji bez zapisanej kwoty, której edycja nie zmienia sprzętu ani dat.
// Tabela dni płatnych firmy działa tylko przy nowej wycenie (N.3), a resztę, czyli ceny dynamiczne
// i zestawy, liczy serwer jak zawsze.
export async function fetchPriceQuote(equipmentIds, dateFrom, dateTo, { regulaDomyslna = false } = {}) {
  if (!Array.isArray(equipmentIds) || !equipmentIds.length || !dateFrom || !dateTo) return null;
  try {
    const res = await axios.post(`${API_BASE}/api/price-quote`, {
      equipmentIds, dateFrom, dateTo, ...(regulaDomyslna ? { defaultPaidDays: true } : {}),
    }, { withCredentials: true });
    return res.data && Array.isArray(res.data.items) ? res.data : null;
  } catch {
    return null;
  }
}

// N.6: kwota zapytania o klasy (rezerwacja ze sztukami z klas) w edycji: sztuki klas, dobrane i niedobrane,
// po cenach klas, sprzęt spoza klas po stawkach z magazynu (GET /api/class-booking/reservations/:id/quote,
// ta sama funkcja liczy kwotę przy zapisie). Zwraca { data } w kształcie wyceny panelu (bez pozycji
// sztuk, więc rozbicia ceny nie ma), { brak, message } (klasa bez ceny w ustawieniach widgetu) albo
// { blad: true } (awaria). Ceny lokalnej nie ma tu jak policzyć, więc po awarii nie ma zapasu.
export async function fetchClassRequestQuote(reservationId, equipmentIds, dateFrom, dateTo) {
  if (!reservationId || !dateFrom || !dateTo) return { blad: true };
  const ids = Array.isArray(equipmentIds) ? equipmentIds.join(',') : '';
  try {
    const res = await axios.get(`${API_BASE}/api/class-booking/reservations/${encodeURIComponent(reservationId)}/quote`, {
      params: { start: dateFrom, end: dateTo, ...(ids ? { equipment: ids } : {}) },
      withCredentials: true,
    });
    const w = res.data;
    if (!w || !Number.isFinite(Number(w.total))) return { blad: true };
    return {
      data: {
        items: [], grandTotal: Number(w.total), days: w.days, chargeableDays: w.chargeable_days, bundles: [], classRequest: true,
      },
    };
  } catch (e) {
    const odp = e && e.response && e.response.data;
    if (odp && odp.code === 'class_price_missing') return { brak: odp.missing || [], message: odp.message || odp.error || '' };
    return { blad: true };
  }
}
